import { lazy, Suspense, useEffect } from 'react';
import { resumeSession } from '../net/session';
import { useSessionStore } from '../store/sessionStore';
import { useSettingsStore } from '../store/settingsStore';
import { HomeScreen } from '../ui/HomeScreen';
import { importMatchScreen } from './matchChunk';

const MatchScreen = lazy(importMatchScreen);

/** Router-less screen switch: in a room → match, otherwise → home. */
export function App() {
  const room = useSessionStore((s) => s.room);
  const uiScale = useSettingsStore((s) => s.uiScale);

  useEffect(() => {
    void resumeSession();
  }, []);

  // On the root element, so the root font size (and with it every rem) follows the setting.
  useEffect(() => {
    document.documentElement.style.setProperty('--ui-scale', String(uiScale));
  }, [uiScale]);

  if (!room) return <HomeScreen />;
  return (
    <Suspense
      fallback={
        <main className="home home-loading">
          <p className="muted">Loading…</p>
        </main>
      }
    >
      <MatchScreen room={room} />
    </Suspense>
  );
}
